import client from './axiosInstance';
import { IUpdateOrganizationData } from '../features/organization/organizationTypes';

export const fetchOrganizationInfo = async (id: number) => {
  return await client.get(`/organizations/${id}`);
};

export const changeOrganizationInfo = async (data: IUpdateOrganizationData) => {
  return await client.patch(`/organizations`, { ...data });
};
